const errorRegex = (smallestUnitValue: string) => {
    let regex = "";
    let errorText = "";
    switch (smallestUnitValue) {
        case "d":
            errorText = "d";
            regex = "dD";
            break;
        case "h":
            errorText = "d h";
            regex = "dhDH";
            break;
        case "m":
            errorText = "d h m";
            regex = "dhmDHM";
            break;
        case "s":
            errorText = "d h m s";
            regex = "dhmsDHMS";
            break;
        default:
            break;
    }

    return { regex, errorText };
};
export const errorText = (smallestUnitValue: string) => {
    const startText = "must be in format ";
    const { errorText } = errorRegex(smallestUnitValue);
    return `${startText}${errorText}`;
};

export const isValidDurationString = (
    value: string,
    smallestUnitValue: string,
    durationError: string,
    setDurationError: (error: string) => void
) => {
    const startRegex = "^(\\d+[";
    const endRegex = "][ ]?)+$";
    const { regex: middleRegex } = errorRegex(smallestUnitValue);
    const regex = `${startRegex}${middleRegex}${endRegex}`;
    if (!value.match(regex)) {
        if (!durationError) {
            setDurationError(errorText(smallestUnitValue));
        }
        return false;
    } else {
        if (durationError) {
            setDurationError("");
        }
        return true;
    }
};

export const getMultiplier = (smallestUnitValue: "s" | "m" | "h" | "d") => {
    const multiplier = {
        s: 1,
        m: 1,
        h: 1,
        d: 1,
    };

    switch (smallestUnitValue) {
        case "s":
            multiplier.m = 60;
            multiplier.h = 60 * 60;
            multiplier.d = 60 * 60 * 24;
            break;
        case "m":
            multiplier.h = 60;
            multiplier.d = 60 * 24;
            break;
        case "h":
            multiplier.d = 24;
            break;
        case "d":
            break;
    }
    return multiplier;
};

export const convertFromUnits = (
    value: string,
    smallestUnitValue: "s" | "m" | "h" | "d",
    durationError: string,
    setDurationError: (error: string) => void
) => {
    if (value == null) return undefined;

    if (isValidDurationString(value, smallestUnitValue, durationError, setDurationError)) {
        const valueWithoutSpaces = value.replace(/\s+/g, "");
        const matches = valueWithoutSpaces.match(/\d+[dhms]/gi);
        if (!matches) return undefined;

        const multiplier = getMultiplier(smallestUnitValue);

        const total = matches.reduce((total, current) => {
            const number = parseInt(current.replace(/[dhms]/gi, ""));
            const unit = current.replace(/[0-9]/gi, "").toLowerCase();
            total += number * multiplier[unit];
            return total;
        }, 0);
        return total;
    }
    return undefined;
};

export const convertToUnits = (smallestUnitValue: "s" | "m" | "h" | "d", value?: number | null) => {
    if (value == null) {
        return;
    }
    if (value === 0) {
        return `0${smallestUnitValue}`;
    }

    const getStr = (unit: string, number: number) => `${number ? `${number}${unit} ` : ""}`;

    const multiplier = getMultiplier(smallestUnitValue);

    const days = Math.floor(value / multiplier.d);
    const hours = Math.floor((value % multiplier.d) / multiplier.h);
    const minutes = Math.floor((value % multiplier.h) / multiplier.m);
    const seconds = value % multiplier.m;

    return `${getStr("d", days)}${getStr("h", hours)}${getStr("m", minutes)}${getStr(
        "s",
        seconds
    )}`.trim();
};
